<script setup lang="ts">
import type { Profile } from "~/common/types/types";
import Joi from 'joi'
import type { FormErrorEvent, FormSubmitEvent } from '#ui/types'
import EditProfile from "./EditProfile.vue";
import { isEntityId } from "../util";

const profile = defineModel({
  required: true,
  type: Object as PropType<Profile>   
})

const schema = Joi.object({
  _id: Joi.custom(isEntityId),
  name: Joi.string().required(),
  orgId: Joi.custom(isEntityId),
  created: Joi.date().required(),
  email: Joi.string().allow(''),
  phone: Joi.string().allow(''),
  github_username: Joi.string().allow(''),
  description: Joi.string().allow(''),
  resume: Joi.string().allow(''),
  socials: Joi.array(),
  communication_languages: Joi.array(),
  programming_languages: Joi.array()
})

const emit = defineEmits(['submitted'])

async function onSubmit () {
  emit('submitted', profile.value);
}

async function onError (event: FormErrorEvent) {
  console.log(event.errors)
}

</script>

<template>
    <UForm :schema="schema" :state="profile" class="space-y-4" @submit="onSubmit" @error="onError" >
      
      <EditProfile v-model="profile" />

      <UButton type="submit" class="mt-3">
        Create Profile
      </UButton>
    </UForm>
</template>